export default {
    root: {
        color: "#008CB4",
    }
}